import React from "react";
import { X } from "lucide-react";

const WhyMSUModal = ({ setOpen }) => (
    <div
        className="fixed inset-0 z-[999] flex items-center justify-center bg-black/70 px-4"
        onClick={() => setOpen(false)}
    >
        <div
            className="relative w-full max-w-4xl"
            onClick={(e) => e.stopPropagation()}
        >
            <div className="aspect-video overflow-hidden rounded-lg bg-black">
                <video
                    src="https://cdn.msu.edu.in/Mr_Pravesh_Dudani_Final_4612a60930.mp4"
                    className="h-full w-full"
                    autoPlay
                    controls
                    poster="https://cdn.msu.edu.in/Screenshot_2025_12_09_184021_13d7002de8.png"  
                />
            </div>
            <button
                type="button"
                onClick={() => setOpen(false)}
                className="absolute -right-2 -top-2 cursor-pointer rounded-full bg-white px-1 py-1 text-sm font-medium text-gray-800 shadow"
            >
                <X />
            </button>
        </div>
    </div>
);

export default WhyMSUModal;
